import { decodeAddress } from "algosdk";
import { CLAIM_TOKEN_PREFIX } from "../constants";
/**
 * algosdk.signBytes domain-separation prefix (the ASCII bytes "MX"). The backend
 * issues tokens with algosdk.signBytes, which prepends this before signing, and the
 * contract verifies against the same prefixed message - so it is baked into the
 * message here too.
 */
const SIGN_BYTES_PREFIX = new TextEncoder().encode("MX");
/**
 * The message a claim token must sign: "MX" + the asset config's claimTokenPrefix +
 * the claimer's 32-byte public key. The "MX" matches algosdk.signBytes domain
 * separation. Sign this with the midnight token signer's ed25519 secret key with a
 * bare signature (e.g. nacl.sign.detached) - which over this message is identical to
 * algosdk.signBytes(claimTokenPrefix + pubkey) - to issue a token for `claimer` on
 * the asset configured with `prefix`.
 */
export function claimTokenMessage(claimer, prefix = CLAIM_TOKEN_PREFIX) {
    const publicKey = decodeAddress(claimer.toString()).publicKey;
    const prefixBytes = new TextEncoder().encode(prefix);
    const message = new Uint8Array(SIGN_BYTES_PREFIX.length + prefixBytes.length + publicKey.length);
    message.set(SIGN_BYTES_PREFIX, 0);
    message.set(prefixBytes, SIGN_BYTES_PREFIX.length);
    message.set(publicKey, SIGN_BYTES_PREFIX.length + prefixBytes.length);
    return message;
}
